import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractDomComponent} from "../../framework/abstract-dom";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-input-dom",
    styleUrls: ["./input-dom.component.scss"],
    templateUrl: "./input-dom.component.html",
    standalone: false
})
export class FUIInputDomComponent extends FUIAbstractDomComponent {
}
